/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CreateSlotsRequestDurationMinutes } from './createSlotsRequestDurationMinutes';
import type { CreateSlotsRequestCapacity } from './createSlotsRequestCapacity';
import type { CreateSlotsRequestRecurrence } from './createSlotsRequestRecurrence';
import type { AppointmentSession } from './appointmentSession';

/**
 * Request to create appointment slots.
 */
export interface CreateSlotsRequest {
  /** Start time for the first slot */
  startTime: string;
  /** End time for the last possible slot (ignored if recurrence is set) */
  endTime: string;
  /** Identifier of the EventKind template to use */
  eventKindId: string;
  /** If provided, the slot is dedicated to these tasks (version-agnostic) */
  boundTaskIds?: string[];
  /** Optional slot duration override in minutes. Applied only if the EventKind allows custom duration. */
  durationMinutes?: CreateSlotsRequestDurationMinutes;
  /** Optional slot capacity override. Applied only if the EventKind allows custom capacity. */
  capacity?: CreateSlotsRequestCapacity;
  /**
   * Break between successive slots when generating a series (ignored if recurrence is set)
   * @minimum 0
   * @maximum 60
   */
  breakMinutes?: number;
  /** Optional recurrence pattern */
  recurrence?: CreateSlotsRequestRecurrence;
  /** Additional sessions for multi-day events (e.g., seminars) */
  extraSessions?: AppointmentSession[];
}
